import parse from 'html-react-parser'

interface OnboardingInstructionsProps {
  instructions: string
}

export const OnboardingInstructions = ({ instructions }: OnboardingInstructionsProps) => {
  return <div className="container d-flex justify-content-center vh-100">{parse(instructions)}</div>
}
